// extracted by mini-css-extract-plugin
export default {"sidebarMenu":"Sidebar_sidebarMenu__nqpQ1"};